// extracted by mini-css-extract-plugin
export default {"Item":"Item_Item__kx+oF","title":"Item_title__uw69N","info":"Item_info__lJLb6","file":"Item_file__wb27V","content":"Item_content__soRzE"};